import { RefObject, useEffect, useState } from 'react';
import throttle from 'lodash-es/throttle';
import { BOTTOM_SHEET_CAPTION_HEIGHT, BOTTOM_SHEET_FOOTER_HEIGHT } from './constants';

const maskPosition = {
  top: BOTTOM_SHEET_CAPTION_HEIGHT - 12,
  bottom: BOTTOM_SHEET_FOOTER_HEIGHT - 1,
};

export function useScrollMask({
  opened,
  scrollWrapperRef,
  calendarRef,
}: {
  opened: boolean;
  calendarRef: RefObject<HTMLElement>;
  scrollWrapperRef: RefObject<HTMLElement>;
}) {
  const [mask, setMask] = useState({
    topMask: 0,
    bottomMask: 0,
  });

  const handleScroll = throttle(() => {
    updateMask();
  }, 1000);

  useEffect(() => {
    // initial trigger first render
    opened && setTimeout(() => updateMask(), 300);
  }, [opened]);

  const updateMask = () => {
    const scrollContainer = scrollWrapperRef.current;
    const calendarContainer = calendarRef.current;

    if (!scrollContainer || !calendarContainer) {
      return;
    }

    if (scrollContainer.scrollHeight > (calendarContainer.offsetHeight ?? 0)) {
      const showTopMask = calendarContainer.scrollTop > 0;
      const showBottomMask =
        calendarContainer.scrollTop + calendarContainer.offsetHeight < calendarContainer.scrollHeight;

      setMask({
        topMask: showTopMask ? 1 : 0,
        bottomMask: showBottomMask ? 1 : 0,
      });
    }
  };

  return {
    mask,
    maskPosition,
    handleScroll,
  };
}
